module.exports = __webpack_public_path__ + "img/research.fe404e6a.png";